module.exports = __webpack_public_path__ + "img/news19-0.66492cd8.png";